import { Button, Input, Popconfirm, Tag } from "antd";
import { useEffect, useState } from "react";
import { MultiTransactionReportData } from "src/libraries/types/report-transaction";
import "./detail-transaction-modal.scss";
import { URL_PATHS } from "src/common/networks/url-paths";
import { post } from "src/common/networks/api-helper";
import ToastifyAdapter from "src/libraries/components/toastify/toastify.adapter";
import convertToCurrency from "src/libraries/utils/convert-to-currency";
import moment from "moment";
type Props = {
  selectedTransaction: MultiTransactionReportData;
  handleCancel: any;
  handleSearch: any;
};

const DetailTransactionModal = ({
  selectedTransaction,
  handleCancel,
  handleSearch,
}: Props) => {
  const { success, errorFromAPI } = ToastifyAdapter();
  const [refundAmount, setRefundAmount] = useState<number>(
    selectedTransaction.amount || 0
  );
  const [confirming, setConfirming] = useState(false);
  const [loading, setLoading] = useState(false);
  useEffect(() => {}, []);
  const changeStatusColor = (text: string) => {
    switch (text) {
      case "2":
        return <Tag color="green">Thành công</Tag>;
      case "1":
        return <Tag color="orange">Khởi tạo</Tag>;
      case "4":
        return <Tag color="red">Hoàn tiền</Tag>;
      case "5":
        return <Tag color="geekblue">Hoàn tiền thành công</Tag>;
      default:
        return <Tag color="gray">Chưa có trạng thái này</Tag>;
    }
  };

  const handleRefund = () => {
    post(
      `${URL_PATHS.REFUND}`,
      {
        billCode: selectedTransaction.referenceLabelCode,
        amount: refundAmount.toString(),
      },
      true,
      true
    )
      .then((res) => {
        if (res && res.status === 200) {
          success("Hoàn tiền thành công");
          handleCancel();
          handleSearch("paginate");
        }
      })
      .catch((e) => {
        console.log("ERROR REFUND TRANSACTION", e);
        handleCancel();
        errorFromAPI(e?.response?.data?.code, e?.response?.data?.error);
      });
  };
  return (
    <div style={{ marginTop: 50 }}>
      <p className="detail-text">
        <strong>Id:</strong> {selectedTransaction.id}
      </p>
      <p className="detail-text">
        <strong>Mã giao dịch:</strong> {selectedTransaction.referenceLabelCode}
      </p>
      <p className="detail-text">
        <strong>FTCode:</strong> {selectedTransaction.ftCode}
      </p>
      <p className="detail-text">
        <strong>Số tiền thanh toán:</strong>{" "}
        <span style={{ color: "green", fontWeight: 700 }}>
          {convertToCurrency(selectedTransaction.amount)}đ
        </span>
      </p>
      <p className="detail-text">
        <strong>Thời gian giao dịch:</strong>{" "}
        {moment(selectedTransaction.payDate, "YYYYMMDDHHmmss").format(
          "DD-MM-YYYY HH:mm:ss"
        )}
      </p>
      <p className="detail-text">
        <strong>Tên kênh thanh toán:</strong>{" "}
        {selectedTransaction.paymentChannelName}
      </p>
      <p className="detail-text">
        <strong>Mã ngân hàng:</strong> {selectedTransaction.bankId}
      </p>
      <p className="detail-text">
        <strong>Số tài khoản:</strong> {selectedTransaction.bankAccountNumber}
      </p>
      <p className="detail-text">
        <strong>Chủ tài khoản:</strong> {selectedTransaction.bankAccountName}
      </p>
      <p className="detail-text">
        <strong>Trạng thái:</strong>{" "}
        {changeStatusColor(selectedTransaction.status)}
      </p>
      {selectedTransaction.status === "4" &&
        selectedTransaction.refundStatus === "200" && (
          <p className="detail-text">
            <strong>Trạng thái hoàn tiền:</strong>
            {<Tag color="green">Thành công</Tag>}
          </p>
        )}
      {selectedTransaction.status === "4" &&
        selectedTransaction.refundStatus === "200" && (
          <p className="detail-text">
            <strong>Số tiền hoàn:</strong>{" "}
            <span style={{ color: "cornflowerblue", fontWeight: 700 }}>
              {convertToCurrency(selectedTransaction.refundAmount)}đ
            </span>
          </p>
        )}
      <div className="refund-input">
        {selectedTransaction.status === "2" && confirming && (
          <div>
            <strong>Nhập số tiền hoàn:</strong>
            <Input
              type="number"
              min={1000}
              max={selectedTransaction.amount}
              value={refundAmount}
              onChange={(e) => setRefundAmount(Number(e.target.value))}
            />

            <div style={{ marginTop: 36, textAlign: "right" }}>
              <Popconfirm
                title={`Xác nhận hoàn ${refundAmount.toLocaleString()}đ?`}
                onConfirm={handleRefund}
                onCancel={() => setConfirming(false)}
                okText="OK"
                cancelText="Hủy"
              >
                <Button
                  type="primary"
                  disabled={
                    refundAmount <= 0 ||
                    refundAmount > selectedTransaction.amount
                  }
                >
                  Xác nhận
                </Button>
              </Popconfirm>
            </div>
          </div>
        )}
        {selectedTransaction.status === "2" && !confirming && (
          <div style={{ marginTop: 36, textAlign: "right" }}>
            <Popconfirm
              title={`Bạn có chắc muốn hoàn tiền ?`}
              onConfirm={() => setConfirming(true)}
              onCancel={() => setConfirming(false)}
              okText="Tiếp tục"
              cancelText="Hủy"
            >
              <Button type="primary" danger>
                Hoàn tiền
              </Button>
            </Popconfirm>
          </div>
        )}
      </div>
    </div>
  );
};

export default DetailTransactionModal;
